
import { defineComponent, ref, Ref } from 'vue';
import { IGroup, IRequestSpacesContact } from '@/types/interfaces';
import { SHARE_ACCESS, PHOTO_VIEW_TYPE } from '@/types/enums';
import { lowResUrlByViewTypeByUrl } from '@/helpers/lowResPhotoUrl';
import BottomPopUpItemWrapper from '../../BottomPopUpItemWrapper.vue';
import BottomPopUpItem from '../../BottomPopUpItem.vue';

export default defineComponent({
  components: {
    BottomPopUpItemWrapper,
    BottomPopUpItem,
  },
  props: {
    contactList: { type: Array as () => IRequestSpacesContact[], required: true },
    groupList: { type: Array as () => IGroup[], required: true },
    selectedAll: { type: Boolean, required: true },
    deselectedAll: { type: Boolean, required: true },
  },
  emits: ['onSelectAll', 'onDeselectAll', 'onSelectContact', 'openSpecificPeople', 'openGroups', 'onSelectGroup'],
  setup() {
    const isShowContacts: Ref<boolean> = ref(false);

    function resolveFullName(contact: IRequestSpacesContact): string {
      return `${contact.user.firstName} ${contact.user.lastName}`;
    }

    function resolveContactPhotoUrl(contact: IRequestSpacesContact): string {
      if (contact.user.photo?.url) {
        return lowResUrlByViewTypeByUrl(contact.user.photo.url, PHOTO_VIEW_TYPE.WHSML);
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/profile.svg');
    }

    function resolveGroupPhotoUrl(group: IGroup): string {
      if (group.photo?.url) {
        return lowResUrlByViewTypeByUrl(group.photo.url, PHOTO_VIEW_TYPE.WHSML);
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/Group.svg');
    }

    return {
      isShowContacts,
      resolveFullName,
      resolveContactPhotoUrl,
      resolveGroupPhotoUrl,
      SHARE_ACCESS,
    };
  },
});
